<template>
  <div class="flex flex-col gap-6 w-47">
    <div
      v-if="!isLoaded"
      class="w-full aspect-188/150 bg-level-2-container animate-pulse rounded-lg"
    ></div>
    <img
      v-show="isLoaded"
      :src="imageSrc"
      alt="not-logged-in"
      class="w-full"
      @load="isLoaded = true"
    />
    <Button type="blue1" size="sm" class="w-full" @click="handleLogin">
      {{ $t('home.user.logIn') }}
    </Button>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'
  import { Button } from '@rapoo/element'
  import { useAnimatedImage } from '@/composables/useAnimatedImage'
  import { getImageUrl } from '@/utils/assets'
  import { useRouter } from 'vue-router'

  const isLoaded = ref(false)
  const { imageSrc } = useAnimatedImage(getImageUrl('header/user/not-logged-in.webp'))

  const router = useRouter()
  const emit = defineEmits<{
    (e: 'open-login-panel'): void
  }>()

  const handleLogin = () => {
    emit('open-login-panel')
    router.push({ name: 'login' })
  }
</script>

<style lang="scss" scoped></style>
